import React, { useState } from 'react';
import { WinItemProps } from '../types';
import './WinItem.css';
import editIcon from '../assets/edit-icon.png';
import deleteIcon from '../assets/delete-icon.png';
import closeIcon from '../assets/close-icon.png';

const WinItem: React.FC<WinItemProps> = ({ win, deleteWinItem, editWinItem }) => {

  const [onEdit, setOnEdit] = useState<boolean>(false);
  const [content, setContent] = useState<string>("");

  const editButtonClick = () => {
    setContent(win.content);
    setOnEdit(true);
  }

  const submitEditAction = () => {
    editWinItem({id: win.id, content: content, date: win.date});
    setOnEdit(false);
  }

  const closeButtonClick = () => {
    setOnEdit(false);
  }

  return (
    !onEdit ? 
    <div className='win-item'>
      <div className='win-item-button-containers'>
        <div className='win-item-edit-container' onClick={e => editButtonClick()}>
          <img src={editIcon} alt='Edit Icon' />
        </div>
        <div className='win-item-delete-container' onClick={(e) => deleteWinItem(win.id)}>
          <img src={deleteIcon} alt='Delete Icon' />
        </div>
      </div>
      <div className='win-content'>
        {win.content}
      </div>
    </div> :
    <div className='win-input-item'>
      <div className='win-input-item-button-container'>
        <div className='win-item-close-container' onClick={e => closeButtonClick()}>
          <img src={closeIcon} alt='Edit Icon' />
        </div>
      </div>
      <input 
        className='win-input-field' 
        placeholder='What have you accomplished today?' 
        autoFocus={true} 
        value={content}
        onChange={(e) => setContent(e.target.value)} />
      <div className='submit-win-button' onClick={(e) => submitEditAction()}>UPDATE</div>
    </div>
  );
};

export default WinItem;
